import { createSessionStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/session-storage/index.tsx';

export const storageProvider = createSessionStorageProvider('sidebar-navigation');
